export default "__VITE_ASSET__073bd230__"